import {ApplicationState} from '../../redux/state';
import { connect } from 'react-redux';
import MainContainer from './MainContainer';

const mapStateToProps = ({product}: ApplicationState) => {
    return {
        clampexType: product.currentProduct.type
    };
}

export default connect(
    mapStateToProps
)(MainContainer)